module.exports = __webpack_public_path__ + "static/media/Project1_HeaderImg.5c8fb468.png";